import { IDBPDatabase, openDB } from 'idb'
import { ILibrePlace } from '@/contracts/modules/libre/entities/ILibrePlace'
import { ILibreData } from '@/contracts/modules/libre/entities/ILibreData'

/** Строка индекса: расшифрованный узел, чтобы после перезагрузки не сворачивать весь журнал */
export interface ILibreIndexRow {
  uuid: string
  place: ILibrePlace | null
  data: ILibreData | null
  isRemoved: boolean
  updatedAt: string | null
  /** false — узел не расшифровался: place и data пусты */
  readable: boolean
}

// Индекс узлов пользователя, как индекс заметок: своя база IndexedDB на учётную запись,
// производное от журнала, пересобирается из него в любой момент
const PREFIX = 'extasy.libre.'
const VERSION = 1
const NODES = 'nodes'

type LibreDb = IDBPDatabase<unknown>

const databases = new Map<string, Promise<LibreDb>>()

function database(userUuid: string): Promise<LibreDb> {
  let db = databases.get(userUuid)
  if (!db) {
    db = openDB(`${PREFIX}${userUuid}`, VERSION, {
      upgrade(upgrading) {
        upgrading.createObjectStore(NODES, { keyPath: 'uuid' })
      },
    })
    databases.set(userUuid, db)
  }
  return db
}

export async function readLibreIndex(userUuid: string): Promise<ILibreIndexRow[]> {
  return (await database(userUuid)).getAll(NODES)
}

export async function writeLibreIndexRow(userUuid: string, row: ILibreIndexRow): Promise<void> {
  await (await database(userUuid)).put(NODES, row)
}

/** Забыть открытые базы: после подмены indexedDB в тестах */
export function closeLibreIndex(): void {
  databases.forEach((db) => db.then((opened) => opened.close()).catch(() => undefined))
  databases.clear()
}
